import { Button } from '@design-system/button';
import { Link } from '@design-system/link';
import React, { FC } from 'react';

import { BurgerOpenerProps } from './models';

export const BurgerOpener: FC<BurgerOpenerProps> = ({
  burgerCloseIcon,
  burgerOpenLabel,
  burgerOpenIcon,
  burgerToggleLabel,
  handleBurgerClick,
  isOpen,
  isJS,
  burgerBtnRef,
  isMobileView,
}) => {
  if (isJS && isMobileView)
    return (
      <Button
        ref={burgerBtnRef}
        variant="subtle-icon"
        className="cds-navigation-mobile__burger"
        size="large"
        iconSuffix={{
          props: isOpen ? burgerCloseIcon : burgerOpenIcon,
        }}
        onClick={handleBurgerClick}
        aria-expanded={!!isOpen}
      >
        {burgerToggleLabel}
      </Button>
    );

  if (isJS && !isMobileView) {
    return null;
  }

  return (
    <Link
      className="cds-global-header__burger-opener"
      variant="subtle-icon"
      href="#open-menu"
      size="large"
      iconSuffix={{
        props: burgerOpenIcon,
      }}
    >
      {burgerOpenLabel}
    </Link>
  );
};
